import React, { useEffect, useState } from "react";
import { AppProvider as PolarisProvider } from "@shopify/polaris";
import { Provider as AppBridgeProvider } from '@shopify/app-bridge-react';
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import createApp from "@shopify/app-bridge";
import { Page, Text } from "@shopify/polaris";
import axios from "axios";
import "./App.css";
import Dashboard from "./Components/Dashboard";
import ArticleDetail from "./Components/ArticleDetail";
import AllPostTable from "./Components/AllPostTable";

const apiKey = process.env.REACT_APP_SHOPIFY_API_KEY;


function AppRedirect() {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shop = searchParams.get("shop");
  const host = searchParams.get("host");
  const [appBridgeError, setAppBridgeError] = useState(null);

  useEffect(() => {
    if (!shop || !host) {
      console.error("Missing shop or host parameters");
      navigate("/error", {
        replace: true,
        state: { error: "Missing shop or host parameters" },
      });
      return;
    }

    const initializeAppBridge = async () => {
      try {
        const app = createApp({
          apiKey,
          host,
          forceRedirect: true,
        });
        console.log("AppBridge initialized:", app);
        navigate(`/dashboard?shop=${shop}&host=${host}`, { replace: true });
      } catch (error) {
        console.error("AppBridge initialization failed:", error);
        setAppBridgeError(error.message);
        window.location.assign(`/?shop=${shop}&host=${host}`);
      }
    };

    if (window.top === window.self) {
      console.log("Not in iframe, redirecting to Shopify admin");
      window.location.assign(`https://${shop}/admin/apps/blogcraftai`);
    } else {
      initializeAppBridge();
    }
  }, [shop, host, navigate]);

  if (!shop || !host || appBridgeError) {
    return (
      <Page title="Error">
        <Text variant="bodyMd" color="critical">
          ⚠️ Error: {appBridgeError || "Missing shop or host parameters"}.
          Please launch from Shopify Admin or enable cookies.
        </Text>
      </Page>
    );
  }

  return null;
}



function App() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopOrigin = searchParams.get("shop") || location.state?.shop;

  return (
    <PolarisProvider>
      {/* <Layout shopOrigin={shopOrigin} apiKey={apiKey}> */}
          <Routes>
            <Route path="/app/" element={<AppRedirect />} />
            
            <Route
              path="/dashboard"
              element={<Dashboard shopOrigin={shopOrigin} apiKey={apiKey} />}
            />
            <Route
              path="/article/:articleId"
              element={<ArticleDetail shopOrigin={shopOrigin} apiKey={apiKey} />}
            />
            <Route path="/all-posts" element={<AllPostTable shopOrigin={shopOrigin} apiKey={apiKey} />} />
            <Route path="/" element={<AppRedirect />} />
          </Routes>
      {/* </Layout> */}
    </PolarisProvider>
  );
}

export default function AppWrapper() {
  // Get shop and host from the URL
  const location = window.location;
  const searchParams = new URLSearchParams(location.search);
  const shopOrigin = searchParams.get("shop");
  const host = searchParams.get("host");

  const config = {
    apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
    host: host, // or shopOrigin if that's what you use
    forceRedirect: true,
  };

  return (
    <BrowserRouter>
      <PolarisProvider config={config}>
        <App className="App" />
      </PolarisProvider>
    </BrowserRouter>
  );
}